export default __webpack_public_path__ + "static/media/aboutus.ca728d92.svg";